<template>
  <table-layout class="order-background rounded rounded-9" title="چت های من" :showSearch="false">
    <template #buttons></template>
    <template #table>
      <table-items :items="items" :restoreState="false"/>
      <div class="row text-center pt-3">
        <div class="mt-3 ml-auto mr-auto color">
          <pagination :meta="paginationMeta" :on-change-page="changePage"/>
        </div>
      </div>
    </template>
  </table-layout>
</template>
<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/Chat/tableItems.vue";

export default {
  name: "UserChats",
  components: {TableLayout, Pagination, tableItems},
  computed: {
    ...mapGetters({
      items: "Chat/getChats",
      paginationMeta: "Chat/getPagination",
    }),
  },
  methods: {
    changePage(page) {
      const form = this.setupRequestForm(page)
      this.$store.dispatch("Chat/getUserChats", form);
    },
    setupRequestForm(page) {
      let user_id = this.$route.query.user
      if (user_id === undefined) {
        user_id = this.$store.getters['User/getUserId']
      }

      return {page: page, user_id: user_id}
    }
  },
  mounted() {
    const form = this.setupRequestForm(1)
    this.$store.dispatch("Chat/getUserChats", form);
  },

};
</script>
<style scoped>
.order-background {
  background: #f3f3f3;
}
</style>